import type {
  ApiReturnProject,
  ApiReturnSite,
} from '@highimpact-frontend/api-types';

export type EntityPropertyTable = 'projects' | 'sites';

/**
 * Reads a string property from a project or site catalog row.
 */
export function resolveEntityPropertyText(
  entityTable: EntityPropertyTable,
  rowId: number,
  property: string,
  projects: readonly ApiReturnProject[],
  sites: readonly ApiReturnSite[]
): string | undefined {
  const record =
    entityTable === 'projects'
      ? projects.find((project) => project.id === rowId)
      : sites.find((site) => site.id === rowId);

  if (!record) {
    return undefined;
  }

  const value = (record as Record<string, unknown>)[property];
  return value == null ? undefined : String(value);
}
